// image-utils.ts
import imageCompression from 'browser-image-compression';

export interface ImageCompressionOptions {
    maxSizeMB?: number;
    maxWidthOrHeight?: number;
    useWebWorker?: boolean;
}

export const compressImage = async (
    file: File,
    options?: ImageCompressionOptions
): Promise<File> => {
    const defaultOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 800,
        useWebWorker: true,
        ...options
    };

    try {
        // Validate file type
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        if (!['png', 'jpeg', 'jpg'].includes(fileExtension || '')) {
            throw new Error('Only PNG and JPEG/JPG images are allowed.');
        }

        // Compress the image
        const compressedBlob = await imageCompression(file, defaultOptions);

        // Return new File with original name
        return new File([compressedBlob], file.name, {
            type: compressedBlob.type,
            lastModified: Date.now()
        });
    } catch (error) {
        console.error('Image compression error:', error);
        throw error;
    }
};

export const createImagePreview = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        try {
            const url = URL.createObjectURL(file);
            resolve(url);
        } catch (error) {
            reject(new Error('Failed to create image preview'));
        }
    });
};

export const validateImageFile = (file: File): boolean => {
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    return validTypes.includes(file.type);
};